import React from 'react';
export function Footer() {
  return <footer className="bg-forest py-8 border-t border-forest-dark text-center px-4" data-id="element-123">
      <div className="max-w-4xl mx-auto" data-id="element-124">
        <p className="text-cream text-sm opacity-80" data-id="element-125">
          © {new Date().getFullYear()} Mega Pack Historia México 360 — Todos
          los derechos reservados.
        </p>
      </div>
    </footer>;
}